module.exports = __webpack_public_path__ + "static/img/gc_microdermabrasion.7db0914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc/gc_microdermabrasion.png
// module id = 304
// module chunks = 1